import { ValidatorFunction } from '../_form-kit/inline-validator/_interfaces/ValidatorFunction';
import { ValidationStateMessage } from '../_form-kit/inline-validator/_interfaces/ValidationStateMessage';

/**
 * Custom validator function for fieldset
 * allows one or more checkboxes to be checked
 * Returns a Promise that resolves an object that conforms to interface ValidationStateMessage
 *
 * @see ValidationStateMessage
 * @see https://github.com/hp-dcss/hp6-web-component-library/tree/develop/src/components/_form/_form-kit/inline-validator/_interfaces/ValidationStateMessage.ts
 * @param formControl FormControl
 * @returns ValidationStateMessage
 */

const oneCheckboxValidator: ValidatorFunction = ({
  formControl,
}): Promise<ValidationStateMessage> => {
  let isValid = false;

  if (formControl.type === 'fieldset') {
    const checkboxes = formControl.querySelectorAll('input[type="checkbox"]');
    const checked = Array.from(checkboxes).filter(
      checkbox => (checkbox as HTMLInputElement).checked,
    );
    if (checked.length > 0) {
      isValid = true;
    }
  }

  const message = undefined;

  // the ValidatorFunction needs to return a Promise that resolves an object that
  // implements interface ValidationStateMessage
  // https://github.com/hp-dcss/hp6-web-component-library/tree/develop/src/components/_form/_form-kit/inline-validator/_interfaces/ValidationStateMessage.ts

  const validation = {
    isValid,
    message,
  };

  return Promise.resolve(validation);
};

export default oneCheckboxValidator;
